import { snapshotSchema as e } from "@scalar/workspace-store/helpers/snapshot-schema";
import { buildRequestBody as t, coerceLeafValueToSchemaType as n, getExample as r, getExampleFromBody as i, getExampleFromSchema as a, needsMultipartEncoding as o, resolveLeafSchema as s, serializeFormPropertyWithEncoding as c, serializeMultipartArray as l, serializeMultipartBody as u } from "@scalar/workspace-store/request-example";
import { isXmlMediaType as d } from "@scalar/helpers/http/is-xml-media-type";
import { getResolvedRef as f, mergeSiblingReferences as p } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { getExampleValue as m, getExplicitExampleText as h } from "@scalar/workspace-store/helpers/get-example-value";
import { serializeStreamExample as g } from "@scalar/workspace-store/helpers/serialize-stream-example";
import { unpackProxyObject as _ } from "@scalar/workspace-store/helpers/unpack-proxy";
//#region src/code-example/helpers/operation-to-har/process-body.ts
var v = (e, t, n) => ({
	name: e,
	value: `@${t}`,
	fileName: t,
	...n ? { contentType: n } : {}
}), y = (e) => !!e && "type" in e && e.type === "string" && "format" in e && e.format === "binary", b = (e, t) => typeof e == "string" && e.startsWith("@") && y(t) ? e.slice(1) : void 0, x = (e, t, r, i = !1, a) => {
	let o = [], u = Array.isArray(e) ? e.filter((e) => !e.isDisabled).map((e) => [String(e.name), e.value]) : Object.entries(e);
	for (let [d, f] of u) {
		if (f == null) continue;
		let u = r ? void 0 : t?.[d];
		if (i && !r) {
			let t = Array.isArray(e) ? n(f, s(a, [d])) : f, r = l(d, Array.isArray(t) ? t : f, u);
			if (r) {
				for (let e of r) e.value instanceof File ? o.push(v(e.key, e.value.name, e.contentType ?? e.value.type)) : o.push({
					name: e.key,
					value: e.value,
					...e.contentType ? { contentType: e.contentType } : {}
				});
				continue;
			}
		}
		let p = u && (u.style !== void 0 || u.explode !== void 0 || u.allowReserved !== void 0), m = p || !i ? void 0 : u?.contentType, h = i && !r ? b(f, s(a, [d])) : void 0, g = r ? null : c(d, f, u);
		if (g) for (let e of g) o.push({
			name: e.key,
			value: e.value
		});
		else if (f instanceof File) {
			let e = _(f);
			o.push(v(d, e.name, m ?? (i ? e.type : void 0)));
		} else if (h !== void 0) o.push(v(d, h, m));
		else if (m && typeof f == "object") o.push({
			name: d,
			value: JSON.stringify(_(f)),
			contentType: m
		});
		else if (i && !r && !p && typeof f == "object" && !Array.isArray(f)) o.push({
			name: d,
			value: JSON.stringify(_(f)),
			contentType: "application/json"
		});
		else if (Array.isArray(f)) for (let e of f) if (e instanceof File) {
			let t = _(e);
			o.push(v(d, t.name, i ? t.type : void 0));
		} else o.push({
			name: d,
			value: String(e)
		});
		else if (typeof f == "object") {
			let e = x(f, void 0, d);
			for (let t of e) o.push({
				name: `${d}.${t.name}`,
				value: t.value
			});
		} else o.push({
			name: d,
			value: String(f),
			...m ? { contentType: m } : {}
		});
	}
	return o;
}, S = ({ requestBody: n, contentType: s, example: c, openapiVersion: l, requestBodyCompositionSelection: v }) => {
	let y = s || Object.keys(n.content)[0] || "", b = y === "other" ? "" : y, S = (e) => `@${_(e).name || "filename"}`, C = n.content[y]?.encoding, w = n.content[y];
	if (w && o(y, w)) {
		let e = c ?? Object.keys(w.examples ?? {})[0] ?? "default", r = t({
			...n,
			"x-scalar-selected-content-type": { [e]: y }
		}, e, v);
		if (r?.mode === "multipart") {
			let e = u(r.value, r.contentType);
			return {
				mimeType: e.contentType,
				text: e.chunks.map((e) => e instanceof File ? S(e) : e instanceof Blob ? "BINARY" : String(e)).join("")
			};
		}
	}
	let T = y === "multipart/form-data" || y === "application/x-www-form-urlencoded";
	if (d(y)) {
		let e = i(n, y, c ?? "", v, l);
		return e ? {
			mimeType: b,
			text: e.value
		} : void 0;
	}
	let E = m(r(n, c, s)), D = h(E, y);
	if (D !== void 0) return {
		mimeType: b,
		text: D
	};
	let O = E?.value;
	if (O !== void 0) {
		let e = typeof O == "object" && O ? _(O) : O;
		return T && typeof e == "object" && e ? {
			mimeType: b,
			params: x(e, C, void 0, y === "multipart/form-data", f(n.content[y]?.schema, p))
		} : e instanceof File ? {
			mimeType: b,
			text: S(e)
		} : {
			mimeType: b,
			text: typeof e == "string" ? e : g(e, y, !1) ?? JSON.stringify(e)
		};
	}
	let k = n.content[y], A = f(k?.schema ?? k?.itemSchema);
	if (A !== void 0) {
		let t = a(e(A), {
			compositionSelection: v,
			mode: "write",
			binaryAsFile: y === "multipart/form-data"
		}, { schemaPath: ["requestBody"] });
		if (t !== void 0) return T && typeof t == "object" && t ? {
			mimeType: b,
			params: x(t, C, void 0, y === "multipart/form-data", A)
		} : {
			mimeType: b,
			text: g(t, y, k?.schema === void 0) ?? (typeof t == "string" ? t : JSON.stringify(t))
		};
	}
};
//#endregion
export { S as processBody };

//# sourceMappingURL=process-body.js.map